module.exports = __webpack_public_path__ + "img/nt15-02-75-1_asm.prt.705ea77e.jpg";